// // import * as React from 'react'
// import './ChapterMenu.css'
// import { /*Chapter,*/ ChapterProgressDto/*, ContentType, Course*/ } from "../Types/CourseTypes";

// interface ChapterMenuProps {
 
//     courseTitle: string;
//   courseDescription: string;

//   chapters: ChapterProgressDto[];
//   currentChapterId: number;

//   onChapterSelect: (chapterId: number) => void;

//   isOpen: boolean;
//   onClose: () => void;
//   progressPercentage: number;
// }
// export const ChapterMenu = ({
//   courseTitle,
//   courseDescription,
//   chapters,
//     currentChapterId,  
//   onChapterSelect,
//   isOpen,
//   onClose,
//   progressPercentage
// }: ChapterMenuProps) => {

//   return (
//     <>
//       {/* Overlay (mobile) */}
//       {isOpen && <div className="chapterMenuOverlay" onClick={onClose} />}

//       <div className={`chapterMenuPanel ${isOpen ? "chapterMenuPanelOpen" : ""}`}>

//         {/* Mobile close button */}
//         <button className="chapterMenuCloseButton" onClick={onClose}>
//           ✕
//         </button>

//         {/* Header */}
//         <div className="chapterMenuHeader">
//           <h3 className="chapterMenuHeaderTitle">{courseTitle}</h3>
// <p className="chapterMenuHeaderDescription">{courseDescription}</p>


//           <div className="chapterMenuHeaderProgressRow">
//             <span>Framsteg: {Math.round(progressPercentage)}%</span>
//             <span>
//               {/* Om du har completed kännsla */}
//               {/* {course.chapters.filter(c => c.completed).length} av {course.chapters.length} kapitel */}
//             </span>
//           </div>
//         </div>

//         {/* Chapter list */}
//         <div className="chapterMenuContent">
//           <h4 className="chapterMenuSectionTitle">Kapitel</h4>

//           <div>
//             {/* {course.chapters.map((chapter) => {

//               const icon = getChapterIcon(chapter);
//               const video = getVideoFromChapter(chapter);

//               return (
//                 <div
//                   key={chapter.id}
//                   className={`
//                     chapterMenuItem
//                     ${currentChapter.id === chapter.id ? "chapterMenuItemActive" : ""}
//                   `}
//                   onClick={() => onChapterSelect(chapter)}
//                 >
                
//                   <div className="chapterMenuItemIcon">
//                     {icon}
//                   </div>

//                   <div className="chapterMenuItemText">
//                     <h5 className="chapterMenuItemTitle">{chapter.title || "Namnlöst kapitel"}</h5>

                  
//                     {video?.duration && (
//                       <span className="chapterMenuItemDuration">
//                         {video.duration}
//                       </span>
//                     )}
//                   </div>
//                 </div>
//               );
//             })} */}
//             {chapters
//   .sort((a, b) => a.sortOrder - b.sortOrder)
//   .map((chapter) => {
//     const isActive = chapter.chapterId === currentChapterId;
//     const isLocked = !chapter.isUnlocked;

//     return (
//       <div
//         key={chapter.chapterId}
//         className={`
//           chapterMenuItem
//           ${isActive ? "chapterMenuItemActive" : ""}
//           ${isLocked ? "chapterMenuItemLocked" : ""}
//         `}
//         onClick={() => {
//           if (!isLocked) onChapterSelect(chapter.chapterId);
//         }}
//       >
//         <div className="chapterMenuItemIcon">
//           {isLocked ? "🔒" : "▶"}
//         </div>

//         <div className="chapterMenuItemText">
//           <h5 className="chapterMenuItemTitle">
//             {chapter.title}
//           </h5>

//           {isLocked && (
//             <span className="chapterMenuItemLockedText">
//               Låses upp {new Date(chapter.unlockDate).toLocaleDateString()}
//             </span>
//           )}

//           {chapter.completedAt && (
//             <span className="chapterMenuItemCompleted">
//               ✔ Klar
//             </span>
//           )}
//         </div>
//       </div>
//     );
//   })}

//           </div>
//         </div>

//       </div>
//     </>
//   );
// };

import "./ChapterMenu.css";
import { ChapterRole, ChapterTreeNode, ContentType } from "../Types/CourseTypes";

interface ChapterMenuProps {
  courseTitle: string;
  courseDescription: string;

  chapters: ChapterTreeNode[];

  expandedChapterIds: number[];
  currentContentId: number | null;

  onToggleChapter: (chapterId: number) => void;
  onSelectContent: (chapterId: number, contentId: number) => void;

  isOpen: boolean;
  onClose: () => void;
  progressPercentage: number;
}

export const ChapterMenu = ({
  courseTitle,
  courseDescription,
  chapters,
  expandedChapterIds,
  currentContentId,
  onToggleChapter,
  onSelectContent,
  isOpen,
  onClose,
  progressPercentage
}: ChapterMenuProps) => {
  const getRoleLabel = (role: ChapterRole) => {
    switch (role) {
      case ChapterRole.Prep:
        return "Uppstartsmodul";
      case ChapterRole.Main:
        return "Huvuddel";
      default:
        return "Standard";
    }
  };

  return (
    <>
      {/* Overlay (mobile) */}
      {isOpen && <div className="chapterMenuOverlay" onClick={onClose} />}

      <div className={`chapterMenuPanel ${isOpen ? "open" : ""}`}>
        {/* Close */}
        <button className="chapterMenuClose" onClick={onClose}>
          ✕
        </button>

        {/* Header */}
        <div className="chapterMenuHeader">
          <h3>{courseTitle}</h3>
          <p>{courseDescription}</p>

          <div className="chapterMenuProgress">
            Framsteg: {Math.round(progressPercentage)}%
          </div>
        </div>

        {/* Tree */}
        <div className="chapterMenuTree">
          {chapters.map(chapter => {
            const isExpanded = expandedChapterIds.includes(chapter.chapterId);
            const isLocked = !chapter.isUnlocked;

            return (
              <div key={chapter.chapterId} className="chapterNode">
                {/* Chapter row */}
                <div
                  className={`chapterRow ${isLocked ? "locked" : ""}`}
                  onClick={() => {
                    if (!isLocked) onToggleChapter(chapter.chapterId);
                  }}
                >
                  <span className="chapterIcon">
                    {isLocked ? "🔒" : isExpanded ? "📂" : "📁"}
                  </span>

                    <span className="chapterTitle">{chapter.title}</span>

                    <span className="chapterRoleLabel">{getRoleLabel(chapter.chapterRole)}</span>

                  {chapter.completedAt && (
                    <span className="chapterCompleted">✔</span>
                  )}
                </div>

                {/* Content list */}
                {isExpanded && !isLocked && (
                  <div className="contentList">
                    {chapter.contents.length === 0 && (
                      <div className="contentEmpty">
                        Inget innehåll ännu
                      </div>
                    )}

                    {chapter.contents.map(content => {
                      const isActive =
                        currentContentId === content.contentId;

                      return (
                        <div
                          key={content.contentId}
                          className={`contentRow ${
                            isActive ? "active" : ""
                          }`}
                          onClick={() =>
                            onSelectContent(
                              chapter.chapterId,
                              content.contentId
                            )
                          }
                        >
                          <span className="contentIcon">
                            {getContentIcon(content.contentType)}
                          </span>

                          <span className="contentTitle">
                            {content.title}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

/* ---------------------------------- */
/* Helpers                            */
/* ---------------------------------- */

function getContentIcon(type: ContentType) {
  switch (type) {
    case ContentType.Video:
      return "🎥";
    case ContentType.Pdf:
      return "📄";
    case ContentType.Attachment:
      return "📎";
    case ContentType.Text:
      return "📝";
    default:
      return "📁";
  }
}
